<div class="label u-font-weight-700"
     [style.height]="labelHeight + 'px'"
     [ngClass]="
     {
     'label--recommended': isRecommended,
     'label--beta': isBeta,
     'label--general': !isRecommended,
     'label--common': isCommon,
      }">{{text}}</div>
